import React, { useEffect, useCallback, useState } from "react";
// styles
import useStyles from "./styles";
import DashboardTabs from "../../components/DashboardTabs";


export default function Dashboard() {
 	const classes = useStyles();

  return (
    <div className={classes.root}>
    <DashboardTabs />
    </div>
  );
}

